import Skeleton from '@mui/material/Skeleton'

import { STICKY_HEADER_HEIGHT_PX } from '@shared/constants'

export const HeaderSkeleton = () => {
  return <Skeleton variant="text" height={STICKY_HEADER_HEIGHT_PX} sx={{ transform: 'scale(1,1)', borderRadius: 0 }} />
}
